import * as decision from '../../decision/state/actions';
import * as folders from '../../folders/state/actions';
import * as user from '../../user/state/actions';
import * as watchers from '../../watchers/state/actions';
import * as notifications from '../../navigation/notification/state/actions';

/* istanbul ignore next */
export default {
  decision,
  folders,
  user,
  watchers,
  notifications,
};
